import * as v from 'valibot';

import { MIType } from '../common.types';

const Field = v.object({
	ref: v.string(),
	description: v.string(),
	value: v.nullish(v.string()),
	error: v.optional(v.string()),
	fixable: v.optional(v.boolean()),
	category: v.optional(v.string()),
	manualInterventionPerformed: v.optional(MIType),
	calculatedAndEnteredDifference: v.optional(v.number()),
	calculatedValue: v.optional(v.string()),
});

export const Data = v.array(
	v.object({
		documentGroup: v.string(),
		error: v.optional(v.array(v.string())),
		documents: v.array(
			v.object({
				documentType: v.string(),
				fileId: v.string(),
				sections: v.array(
					v.object({
						sectionId: v.number(),
						sectionName: v.string(),
						fields: v.array(Field),
					}),
				),
			}),
		),
	}),
);

export type Data = v.InferOutput<typeof Data>;
export type Field = v.InferOutput<typeof Field>;

const Group = v.nullable(v.union([v.literal('Expense'), v.literal('Revenue')]));

const Section = v.object({
	sectionId: v.number(),
	sectionName: v.string(),
	fields: v.array(Field),
	numeric: v.boolean(),
	group: Group,
	groupSelect: v.boolean(),
	hideSingleFieldHeaders: v.boolean(),
	enableAddRemove: v.optional(
		v.union([v.literal('NumericRefs'), v.literal('All')]),
	),
});

const FullData = v.array(
	v.object({
		documentGroup: v.string(),
		error: v.optional(v.array(v.string())),
		documents: v.array(
			v.object({
				documentType: v.string(),
				fileId: v.string(),
				sections: v.array(Section),
				hideRefs: v.boolean(),
			}),
		),
	}),
);

export type FullData = v.InferOutput<typeof FullData>;
export type Section = v.InferOutput<typeof Section>;
export type Group = v.InferOutput<typeof Group>;

const ValueUpdate = v.object({
	ref: v.string(),
	value: v.string(),
	remove: v.optional(v.boolean()),
});
const CategoryUpdate = v.object({
	ref: v.literal(''),
	value: v.null(),
	description: v.string(),
	category: v.string(),
});
const AddedUpdate = v.object({
	ref: v.string(),
	value: v.null(),
	description: v.string(),
	category: v.optional(v.string()),
});
const BothUpdate = v.object({
	...CategoryUpdate.entries,
	...ValueUpdate.entries,
});
const FieldUpdate = v.union([
	ValueUpdate,
	CategoryUpdate,
	AddedUpdate,
	BothUpdate,
]);

export type FieldUpdate = v.InferOutput<typeof FieldUpdate>;

const DataBody = v.object({
	documents: v.array(
		v.object({
			documentType: v.string(),
			sections: v.array(
				v.object({
					sectionId: v.number(),
					fields: v.array(FieldUpdate),
				}),
			),
		}),
	),
});

export type DataBody = v.InferOutput<typeof DataBody>;

export const Categories = v.array(
	v.object({
		id: v.string(),
		name: v.string(),
	}),
);

export type Categories = v.InferOutput<typeof Categories>;

// these are the keys that can return in propertyErrors
export const DataErrorKeys = ['financial Year'] as const;

export type DataError = {
	[key in (typeof DataErrorKeys)[number]]: string;
};
